import React, { useState, useContext } from "react"
import { AppContext } from "../App"
import Autosuggest from "react-autosuggest"
import * as geolib from "geolib";

function GuessComponent() {

    const renderSuggestion = suggestion => (
        <div className="suggestion">
            <span>{suggestion.name}</span>
        </div>
    );

    const getSuggestionValue = suggestion => suggestion;

    const { rows, setRows, currAttempt, setCurrAttempt, chosenCountry, countries, setGameStatus, setModalOpen, setHintModalOpen } = useContext(AppContext)

    const [suggestions, setSuggestions] = useState([])
    const [userGuess, setUserGuess] = useState("")

    const getHint = () => {
        setHintModalOpen(true)
    }

    const validateGuess = (guess) => {
        if (guess === null || guess === '') {
            return false
        }
        let matchingCountry = countries.find(country => guess.trim().toLowerCase() === country.name.toLowerCase())
        if (matchingCountry == null) {
            return false //dont let them submit a guess for a country that is not in our list
        }
        return true;
    }

    const submitUserGuess = () => {
        if (currAttempt > 5) {
            return  //dont let them try guessing after their 6th try
        }
        let guess = userGuess;

        if (!validateGuess(guess)) {
            return
        }

        let matchingCountry = countries.find(country => guess.trim().toLowerCase() === country.name.toLowerCase())

        let newCurrAttemptCount = currAttempt + 1
        setCurrAttempt(newCurrAttemptCount)
        setUserGuess('')

        guess = matchingCountry.name    //fix any spelling issues
        console.log(guess)

        //win condition
        if (guess.toLowerCase() === chosenCountry.name.toLowerCase()) {
            let tempGameStatus = {
                correctGuess: true,
                isGameOver: true
            }
            setGameStatus(tempGameStatus)
            setModalOpen(true)
        }
        //lose condition
        else if (newCurrAttemptCount >= 6) {
            let tempGameStatus = {
                correctGuess: false,
                isGameOver: true
            }
            setGameStatus(tempGameStatus)
            setModalOpen(true)
        }

        let direction = geolib.getCompassDirection(matchingCountry, chosenCountry)
        let distanceOff = geolib.getDistance(matchingCountry, chosenCountry)

        //multiply by the constant in order to get miles
        distanceOff = Math.round(distanceOff * 0.000621371)

        let newRows = [...rows]

        newRows[currAttempt] = guess + (distanceOff === 0 ? '' : " (" + distanceOff + " mi away " + fetchDirectionEmoji(direction) + ")")
        setRows(newRows)
    }

    const fetchDirectionEmoji = (direction) => {
        let emojiString = "";
        switch (direction) {
            case "N":
                emojiString = "⬆️"
                break
            case "WNW":
            case "NW":
            case "NNW":
                emojiString = "↖️"
                break
            case "W":
                emojiString = "⬅️"
                break
            case "SSW":
            case "SW":
            case "WSW":
                emojiString = "↙️"
                break
            case "S":
                emojiString = "⬇️"
                break
            case "ESE":
            case "SE":
            case "SSE":
                emojiString = "↘️"
                break
            case "E":
                emojiString = "➡️"
                break
            case "NNE":
            case "NE":
            case "ENE":
                emojiString = "↗️"
                break
            default:
                break
        }
        return emojiString
    }

    const onSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(countries.filter(f => f.name.toUpperCase().includes(value.toUpperCase())))
    }

    return (
        <div>
            <div className="suggestions">
                {
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={() => setSuggestions([])}
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        inputProps={{
                            className: "suggestionInput",
                            placeholder: "Guess the flag's country here!",
                            value: userGuess,
                            onChange: (e, { newValue }) => {
                                if (typeof newValue === "string") {
                                    setUserGuess(newValue)
                                } else {
                                    setUserGuess(newValue.name)
                                }
                            }
                        }}
                    />
                }

            </div>
            <div>
                <button
                    className="button guessButton"
                    onClick={submitUserGuess}
                    disabled={currAttempt > 5 || !validateGuess(userGuess)}
                    title={!validateGuess(userGuess) ? 'Invalid Guess' : ''}>
                    Guess
                </button>

                <button
                    className="button hintButton"
                    onClick={getHint}
                    disabled={currAttempt > 5}>
                    Hint
                </button>
            </div>

        </div>
    )
}

export default GuessComponent